/**
 * Коллекции
 */

import { buildRoute } from '@direct-frontend/modules-router';

export type CollectionEditParams = { collectionId: string };
export type CollectionEditCardsAction = 'add' | 'remove';
export type CollectionEditCardsActionParams = CollectionEditParams & {
    action: CollectionEditCardsAction;
};

export const COLLECTIONS_SEARCH_PARAM_ACTIVE_TAB = 'active-tab' as const;
export const COLLECTIONS_SEARCH_PARAM_PAGE = 'collectionPage' as const;
export const COLLECTIONS_SEARCH_PARAM_PER_PAGE = 'collectionPerPage' as const;
export const COLLECTIONS_SYSTEM_SEARCH_PARAM_PAGE = 'systemCollectionPage' as const;
export const COLLECTIONS_SYSTEM_SEARCH_PARAM_PER_PAGE = 'systemCollectionPerPage' as const;
export const COLLECTIONS_PAGINATION_SEARCH_PARAMS = [
    COLLECTIONS_SEARCH_PARAM_PAGE,
    COLLECTIONS_SYSTEM_SEARCH_PARAM_PAGE,
] as const;

export type CollectionsSearchParams = {
    [COLLECTIONS_SEARCH_PARAM_ACTIVE_TAB]?: 'regular' | 'context' | 'system';
    [COLLECTIONS_SEARCH_PARAM_PAGE]?: string;
    [COLLECTIONS_SEARCH_PARAM_PER_PAGE]?: string;
    [COLLECTIONS_SYSTEM_SEARCH_PARAM_PAGE]?: string;
    [COLLECTIONS_SYSTEM_SEARCH_PARAM_PER_PAGE]?: string;
};

export const collectionsRoute = buildRoute<never, CollectionsSearchParams>('/collections');
export const collectionEditRoute = buildRoute<CollectionEditParams>('/collection/:collectionId');
export const collectionEditCardsActionRoute = buildRoute<CollectionEditCardsActionParams>(
    '/collection/:collectionId/cards/:action'
);

export type ContextCollectionEditParams = { contextCollectionId: string };
export const contextCollectionEditRoute = buildRoute<ContextCollectionEditParams>(
    '/contextCollection/:contextCollectionId'
);
